(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('RegionalProduct', RegionalProduct);

    RegionalProduct.$inject = ['$resource'];

    function RegionalProduct ($resource) {
        var resourceUrl =  'api/regional-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
